<script setup>
import Setup from './Setup.vue';  
import {useDesignLabStore} from "../DesignLabStore.js"
import {GetImageUrl} from "~/javascripts/utils.js";
import {onMounted, onUnmounted, ref} from 'vue';
import {Debounce} from "~/javascripts/common.js";
import { fabric } from 'fabric'

const designLabStore = useDesignLabStore();
const designAreaIcon = GetImageUrl("icons/design_area_icon.svg");

onMounted(async ()=>{
  await designLabStore.getDesignCheckInfo();
  initScaleImages();
});

const initScaleImages = () => {
  window.addEventListener('resize', Debounce(scaleImages, 100));
}

const scaleImages = () => {
  document.querySelectorAll('.js-scale-image').forEach(el => {
    scaleImage(el);
  });
}

const scaleImage = (element) => {
  if (!element) return;
  const w = document.body.clientWidth > 500 ? 500 : document.body.clientWidth;
  const scaleRatio = w / 703;
  element.style.cssText = `transform: scale(${scaleRatio}); transform-origin: 0 0;` 
}

onUnmounted(() => {
  window.removeEventListener('resize', scaleImages);
});

</script>

<template>
  <Setup title="設計稿確認">
    <template #content>
      <!-- 圖片展示 -->
      <div id="design-carousel" class="carousel mk-carousel slide design-lab-carousel">
        <!-- 主要圖片顯示區 -->
        <div class="carousel-inner">
          <div v-for  = "(url, index) in designLabStore.previewImages" 
               :key   = "`m${index}`" 
               :class = "{'active': index == 0}"
               class  = "carousel-item" 
          >
            <div class="mk-carousel__image">
              <div class="mk-image-box">
                <img :src="url" loading="lazy" class="js-scale-image" @load="scaleImage($event.target)" v-if="url">
                <img src="https://placehold.co/200" loading="lazy" v-else>
              </div>
            </div>
          </div>
        </div>

        <!-- 顯示前一個圖片的按鍵 -->
        <button type="button" class="carousel-control-prev" data-bs-target="#design-carousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </button>

        <!-- 顯示後一個圖片的按鍵 -->
        <button type="button" class="carousel-control-next" data-bs-target="#design-carousel" data-bs-slide="next">
          <span class="carousel-control-next-icon"></span>
        </button>

        <!-- 預覽圖片 -->
        <div class="carousel-indicators">
          <div class="carousel-indicators-inner">
            <button  
              type              ="button"
              data-bs-target    ="#design-carousel" 
              :data-bs-slide-to ="index"
              v-for             = "(url, index) in designLabStore.previewImages" 
              :key              = "`p${index}`"
              :class            = "{'active': index == 0}"
            >
              <img :src="url" loading="lazy" v-if="url">
              <img src="https://placehold.co/80" loading="lazy" v-else>
            </button>
          </div>
        </div>

      </div>

      <!-- 產品資訊 -->
      <div style="padding: 0 1rem">
        <h3>設計編號：{{ designLabStore.design.mok_id }}</h3>
        <h3>印製工藝：{{ designLabStore.design.printing_process }}</h3>
        <h2>售價：<span class="mk-price">${{designLabStore.checkInfo.priceWithAreas}}</span></h2>     

        <!-- 單價明細  -->
        <div class="accordion accordion-flush mk-accordion">
          <div class="accordion-item">
            <div class="accordion-header">
              <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-design-price-info">
                <div>單價明細</div>
              </button>
            </div>

            <div class="accordion-collapse collapse show" id="collapse-design-price-info">
              <div class="accordion-body">
                <table class="table table-borderless">
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td>
                        <img :src="designAreaIcon" class="me-1">
                        <span>商品</span>
                      </td>
                      <td>${{ designLabStore.checkInfo.price }}</td>
                    </tr>
                    <tr
                      v-for="(item, index) in designLabStore.checkInfo.designAreaPrices"
                      :key="`design_area_calc_list${index}`"
                    >
                      <td>
                        <img :src="designAreaIcon" class="me-1">
                        <span>{{`${item.title} ${item.designMagnitudeDesc} 印刷價格`}}</span>
                        <span v-show="item.designFree" class="badge bg-mok mx-1">優惠</span>
                      </td>
                      <td>${{item.designPrice}}</td>
                    </tr>
                    <tr class="border-top">
                      <td></td>
                      <td>${{designLabStore.checkInfo.priceWithAreas}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- 折扣區間  -->
        <div class="accordion accordion-flush mk-accordion">
          <div class="accordion-item">
            <div class="accordion-header">
              <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-design-discount-info">
                <div>折扣區間</div>
              </button>
            </div>

            <div class="accordion-collapse collapse show" id="collapse-design-discount-info">
              <div class="accordion-body">
                <div class="row justify-content-end my-1" style="color: #EE7C26 ;font-size: 0.8rem;">合併折扣-適用所有訂單總數量</div>
                <div class="row">
                <table class="table table-bordered text-center">
                  <thead>
                    <tr class="bg-mok text-white">
                      <td scope="col">件數</td>
                      <td scope="col">折扣區間</td>
                      <td scope="col">製作天數</td>
                      <td scope="col">合併折扣</td>
                      <td scope="col">參考價</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in designLabStore.checkInfo.amountPriceInfo"
                      :key="`amountPriceInfo${index}`"
                    >
                      <td class="table-secondary">{{ item.title }}</td>

                      <td class="table-light" :style="item.extraPrice ? 'color: #EE7C26;' : ''">{{ item.procDesc }}</td>
                      <td class="table-light" :style="item.extraPrice ? 'color: #EE7C26;' : ''">{{ item.deliveryDate }}</td>
                      <td class="table-light" :style="item.extraPrice ? 'color: #EE7C26;' : ''">{{ item.mergeDiscount ? "✓" : "☓" }}</td>
                      <td class="table-light" :style="item.extraPrice ? 'color: #EE7C26;' : ''">{{ item.price }}</td>
                    </tr>
                    <tr>
                      
                      <td class="table-light" colspan="5">
                        <!-- 目前先不動態調整 -->
                        單款採購未滿五件, 每件需加+300版費, 且不列入總數量合併折扣
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 產品訊息 -->
        <div class="accordion accordion-flush mk-accordion">
          <div class="accordion-item">
            <div class="accordion-header">
              <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-design-product-info">
                <div>產品訊息</div>
              </button>
            </div>

            <div class="accordion-collapse collapse show" id="collapse-design-product-info">
              <div class="accordion-body">
                <h3>{{`${designLabStore.design.title}(${designLabStore.design.color.name})`}}</h3>
                <ul>
                  <li>
                    <span>顏色：</span> 
                    <span class="d-inline badge" :style="designLabStore.colorBadgeStyle">{{ designLabStore.design.color.name }}</span>
                  </li>

                  <li>
                    <span>型號：</span>
                    {{ designLabStore.design.sku }}
                  </li>

                  <div v-html="designLabStore.design.description"></div>
                </ul>
              </div>
            </div>
          </div>
        </div>                           
      </div>
    </template>

    <template #action>
      <!-- 動作 -->
      <div class="mk-btn-group w-100">
        <button class="mk-btn w-50" @click="designLabStore.goToNextSetup()">保存設計</button>
        <button class="mk-btn w-50" @click="designLabStore.goToShoppingCartModeSetup()">立即購買</button>
      </div>
    </template>
  </Setup>
</template>